import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import Title from '../components/resources/title'
import QuestionAnswers from "../components/resources/questions_answers"
import PeopleAlsoAsk from "../components/resources/people_also_ask"
import ContentSection from "../components/resources/content_section"
import ResourcesDemo from "../components/resources/demo_section"
import BarnacleSeoBanner from "../components/resources/barnacle_seo_banner"
import HeroImageAndVideoContents from "../components/resources/hero_image_and_video_content"
import FAQSection from "../components/resources/resources_faq"
import IntroParagraphContents from "../components/resources/intro_paragraph_contents";
import TableOfContents from "../components/resources/table_of_contents"
import TableOfContentsMobile from "../components/resources/table_of_contents_mobile"
import Layout from "../components/layout"
import AuthorBlock from '../components/author_block'
import OptionalDefinitions from "../components/resources/optional_definitions"
import ResourcesStructuredData from "../components/resources/structured_data_resources"
import Seo from "../components/seo"
import handleResourceLink from "../hooks/handleArticleLink"

const ResourcePostTemplate = ({ data: { previous, next, post, site, avatars } }) => {
  //get featured image if it exists
  const featuredImage = {
    data: post.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData,
    alt: post.featuredImage?.node?.alt || ``,
  }

  let authorPhoto;
  post.author.node.avatar.url ? authorPhoto = post.author.node.avatar.url : authorPhoto = '';
  
  const resourceUrl = handleResourceLink(post);
  const secondaryAuthor = post.secondaryAuthor;
  //converting author name into slug using regex
  const secondaryAuthorSlug = secondaryAuthor.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')
  const allAvatars = avatars.nodes[0].socialMediaLinks;
  function findItemByFullName(fullName) {
    const [firstName, lastName] = fullName.split(' ');
    return allAvatars.find(item => item.lastName === lastName);
}

  // Example usage
  const secondaryAuthorSearchResult = findItemByFullName(secondaryAuthor);
  let secondaryAuthorPhoto;
  !secondaryAuthorSearchResult ? secondaryAuthorPhoto = "https://secure.gravatar.com/avatar/0c853b3aaff9f03e78e77e5b40792246?s=96&r=g" : secondaryAuthorPhoto = secondaryAuthorSearchResult.avatarUrl;

  const authorData = {
    name: post.author.node.name || 'Doctor Genius Marketing',
    date: post.date || ``,
    photo: authorPhoto,
    userName: post.author.node.slug,
    fbLink: '',
    twLink: '',
    instaLink: '',
    linkedInLink: ''
  }

  const secondaryAuthorData = {
    name: secondaryAuthor || 'Doctor Genius Marketing',
    date: post.date || ``,
    photo: secondaryAuthorPhoto,
    userName: secondaryAuthorSlug,
    fbLink: '',
    twLink: '',
    instaLink: '',
    linkedInLink: ''
  }
  const heroContent = {
    video: post.optionalVideo || ``,      
    videoText: post.videoDesc || ``,   
  }

  const introParagraphsContent = post.introParagraph || ``;

  const sectionOne = {
    headline: post.contentOneHeadline || ``,
    content: post.contentOneParagraphs || ``,
    pullquote: post.contentOnePullquote || ``,
  }

  const sectionTwo =  {
    headline: post.contentTwoHeadline || ``,
    content: post.contentTwoParagraphs || ``,
    pullquote: post.contentTwoPullquote || ``,
  }

  const sectionThree =  {
    headline: post.contentThreeHeadline || ``,
    content: post.contentThreeParagraphs || ``,
    pullquote: post.contentThreePullquote || ``,
  }

  const barnacleBannerContent = post.barnacleSeoSection || ``;
  const questionsAnsweredContent = post.questionsOnThisPage || ``;
  const peopleAlsoAskContent = post.peopleAlsoAsk || ``;
  const faqContent = post.faqSection || ``;
  const definitionsContent = post.definitionsSection || ``;
  const tocContent = post.tableOfContentsSection || ``;
  const pageDescription = post.pageDescription || ``;

  const originalSite = site.siteMetadata.siteUrl;
  const optionalVideo = parse(post.optionalVideo);
  let srcWebp;
  // This is checking if the nested property (srcWebp) within the post object is falsy. 
  // If it is, it assigns an empty string to the variable srcWebp; otherwise, it assigns the actual value.
  if (post.featuredImage && post.featuredImage.node) {
      !post.featuredImage.node.localFile.childImageSharp.fluid.srcWebp ? srcWebp = '' : srcWebp = post.featuredImage.node.localFile.childImageSharp.fluid.srcWebp
  }


    return (
      <Layout>
        <ResourcesStructuredData 
        title={post.title}
        pageDescription={pageDescription}
        image= {featuredImage}
        date= {post.date}
        pageUrl= {resourceUrl}
        imageURL = {originalSite+srcWebp}

        />
        <Title sectionContent={post.title} tocContent={tocContent}/>
        <TableOfContentsMobile sectionContent={tocContent}/>
        <div className="container">
          <div className="row">
            <div className={tocContent !== '' ? "col-sm-12 col-md-12 col-lg-7" : "col-sm-12 col-md-12 col-lg-10 offset-lg-1"}>
              <div className="row">
                <div className="col">
              <AuthorBlock authorDetails={authorData} />
              </div>
              
                { secondaryAuthor !== "" && secondaryAuthor !== "None"
                ? <div className="col">
                    <AuthorBlock authorDetails={secondaryAuthorData}/>
                  </div>    
                :null}
                
                </div>
                {
                  featuredImage.data && optionalVideo.length === 0 
                    ? <HeroImageAndVideoContents featuredImage={featuredImage} heroContent={heroContent} /> 
                    : optionalVideo
                }
              {introParagraphsContent !== '' ? <IntroParagraphContents sectionContent={introParagraphsContent}/> : null}
              {sectionOne !== '' ? <ContentSection sectionContent={sectionOne}/> : null}
              {sectionTwo !== '' ? <ContentSection sectionContent={sectionTwo}/> : null}
              {barnacleBannerContent !== '' ? <BarnacleSeoBanner sectionContent={barnacleBannerContent}/> : null}
              {sectionThree !== '' ? <ContentSection sectionContent={sectionThree}/> : null}
              <ResourcesDemo 
                strapline="Patient Experience (PX)"
                headlineBold="Keep Patients Delighted and Happy to Return"
                paragraph="Automate patient communication to keep them informed, happy to share their positive experiences, and eager to learn more about your services."
                buttonHref="/demo"
                buttonText="Schedule A Demo"
                info="No Credit Card Required"
              />
              {questionsAnsweredContent !== '' ? <QuestionAnswers sectionContent={questionsAnsweredContent} /> : null}
              {peopleAlsoAskContent !== '' ? <PeopleAlsoAsk sectionContent={peopleAlsoAskContent} /> : null}
              {faqContent !== '' ? <FAQSection sectionContent={faqContent} /> : null}
              {definitionsContent !== '' ? <OptionalDefinitions sectionContent={definitionsContent}/> : null}
            </div>
              {tocContent !== '' ?
                <div className="col-lg-4 offset-md-1">
                  <TableOfContents sectionContent={tocContent}/>
                </div> 
              : null}
          </div>
      </div>
      </Layout>
    )
  }
  
  export default ResourcePostTemplate
  
  export const Head = ({ data: { post, site } }) => 
  <Seo 
  image={post.featuredImage && post.featuredImage.node && post.featuredImage.node.localFile && post.featuredImage.node.localFile.childImageSharp ? site.siteMetadata.siteUrl + post.featuredImage.node.localFile.childImageSharp.fluid.srcWebp : null}
  title={post.metaTitleSection + " | The Study"} 
    description={post.metaDescriptionSection} 
  />

  export const pageQuery = graphql`
    query ArticlePostById(
      $id: String!
      $previousPostId: String
      $nextPostId: String
    ) {
      site: site {
        siteMetadata {
          siteUrl
        }
      }
      avatars: allWp {
        nodes {
          socialMediaLinks {
            lastName
            avatarUrl
          }
        }
      }
      post: wpResource(id: { eq: $id }) {
        id
        secondaryAuthor
        articleCategory
        barnacleSeoSection
        contentOneHeadline
        contentOneParagraphs
        contentOnePullquote
        contentTwoHeadline
        contentTwoParagraphs
        contentTwoPullquote
        contentThreeHeadline
        contentThreeParagraphs
        contentThreePullquote
        faqSection
        peopleAlsoAsk
        optionalVideo
        videoDesc
        questionsOnThisPage
        definitionsSection
        tableOfContentsSection
        introParagraph
        metaDescriptionSection
        metaTitleSection
        author {
          node {
            name
            slug
            avatar {
              url
            }
          }
        }
        title
        date(formatString: "MMMM DD, YYYY")
        featuredImage {
          node {
            sourceUrl
            altText
            localFile {
              childImageSharp {
                fluid {
                  srcWebp
                }
                gatsbyImageData(
                  quality: 100
                  placeholder: DOMINANT_COLOR
                  layout: CONSTRAINED
                )
              }
            }
          }
        }
        pageDescriptionSection
        professionalDescriptionSection
        uri
      }
      previous: wpResource(id: { eq: $previousPostId }) {
        uri
        title
        slug
      }
      next: wpResource(id: { eq: $nextPostId }) {
        uri
        title
        slug
      }
    }
`;
